import { render, staticRenderFns } from "./transfer_detail.vue?vue&type=template&id=41adfb32"
import script from "./transfer_detail.vue?vue&type=script&lang=js"
export * from "./transfer_detail.vue?vue&type=script&lang=js"
import style0 from "./transfer_detail.vue?vue&type=style&index=0&id=41adfb32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports